// src/constants/terms.js
export const TERMS_TEXT = `
By creating an account you acknowledge and agree to FirstLand’s Terms & Conditions and Privacy Policy, including that:

• Eligibility & Account
– You’re at least 18 years old and will provide accurate contact information.
– You’re solely responsible for maintaining your password and all activity under your account.

• Permitted Use & Conduct
– You’ll use FirstLand lawfully and respectfully, without posting prohibited or infringing content.
– You retain ownership of anything you post but grant us a license to display and promote it.

• Privacy, Data & Cookies
– You consent to our collection, use and sharing of your data as described in our Privacy Policy.
– You accept our Cookie Notice for site functionality, analytics and fraud prevention.

• Subscriptions & Payments
– Paid features (e.g. premium listings, pro subscriptions) are billed via Stripe, include trial periods, auto‑renew, and are non‑refundable unless required by law.

• Liability & Disputes
– FirstLand’s liability is limited as set out in the Terms. You agree to indemnify FirstLand for your misuse.
– Any disputes are governed by Florida law and resolved via the Miami‑Dade courts or binding arbitration.

• Changes to Terms
– We may update these Terms at any time; continued use after notice means you accept the changes.
`;
